import * as colors from './colors';
import * as fontSizes from './fontSizes';
import * as spacing from './spacing';

export default {
  colors,
  spacing,
  fontSizes,
};
